import { Stack, styled } from '@mui/material';

import breakpoints from '../../../constants/breakpoints';

export const Content = styled(Stack)(({ theme }) => ({
  borderRadius: 'var(--border-radius-tiny)',
  gap: 'var(--spacing-small)',
  [theme.breakpoints.up(breakpoints.mobileL)]: {
    backgroundColor: 'var(--color-grey-lighter)',
    paddingBlock: 'var(--spacing-small)',
  },
}));

export const Wrapper = styled(Stack)(({ theme }) => ({
  gap: 'var(--spacing-medium)',
  [theme.breakpoints.up(breakpoints.mobileL)]: {
    paddingBlock: 'var(--spacing-small)',
    paddingInline: 'var(--spacing-big)',
  },
}));
